import { useCompetition } from "../../../../redux/features/categories/selectors";
import dayjs from "dayjs";
import { useContext } from "react";
import { HouseCompetitionData } from "../contextProvider";

const EndsBadge = ({ className = "" }: { className?: string }) => {
  const houseCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });
  const { competitionState } = useContext(HouseCompetitionData);
  let badgeMessage = "Finished";
  const days = dayjs(houseCompetition.EndDate).diff(dayjs(), "days");
  switch (competitionState) {
    case "over14Weeks": {
      badgeMessage = `Ends in ${days} ${days === 1 ? "day" : "days"}`;
      break;
    }
    case "nextWeek": {
      badgeMessage = "Ends next week";
      break;
    }
    case "thisWeek": {
      badgeMessage = "Ends this week";
      break;
    }
    case "last3Days": {
      badgeMessage = "Ends in 3 days";
      break;
    }
    case "today":
    case "last2Days": {
      badgeMessage = "Final hours";
      break;
    }
  }
  return (
    <div
      className={`absolute z-10 flex size-20 lg:size-[100px] flex-col justify-center items-center gap-2 bg-black px-[15px] lg:px-4 py-6 lg:py-[19px] rounded-full ${className}`}>
      <span
        className={"text-white text-center font-jost text-base lg:text-lg font-bold leading-4 lg:leading-6 uppercase"}>
        {badgeMessage}
      </span>
    </div>
  );
};

export default EndsBadge;
